import React, { forwardRef } from "react";
import { Label, Span, StyledFieldSet } from "./FieldSet.style";
import { Input } from "../Input";
import { InputNumber, InputNumeric } from "../Increment";
import { DatePicker } from "../DatePicker";
import { AutoComplete } from "../AutoComplete";
import { Upload } from "../Upload";
import { Textarea } from "../TextArea";
import { InputPassword } from "../Password";
import { CheckBox } from "../CheckBox";

const FieldSet = forwardRef((props, ref) => {
  const { label, type, required, fullWidth, options, ...rest } = props;

  const lowerCase = label?.toLowerCase();

  switch (type) {
    case "text":
      return (
        <StyledFieldSet>
          <Label>
            {lowerCase === "co2e" ? (
              <Span disabled={props?.disabled}>
                Co<sub>2</sub>e {`${required ? "*" : ""}`}
              </Span>
            ) : (
              <Span disabled={props?.disabled}>{`${label} ${
                required ? "*" : ""
              }`}</Span>
            )}
          </Label>
          <Input ref={ref} {...rest} />
        </StyledFieldSet>
      );

    case "textNumeric":
      return (
        <StyledFieldSet>
          <Label>
            {lowerCase === "co2e" ? (
              <Span disabled={props?.disabled}>
                Co<sub>2</sub>e {`${required ? "*" : ""}`}
              </Span>
            ) : (
              <Span disabled={props?.disabled}>{`${label} ${
                required ? "*" : ""
              }`}</Span>
            )}
          </Label>
          <InputNumeric ref={ref} {...rest} />
        </StyledFieldSet>
      );

    case "number":
      return (
        <StyledFieldSet>
          <Label>
            <Span disabled={props?.disabled}>{`${label} ${
              required ? "*" : ""
            }`}</Span>
          </Label>
          <InputNumber {...rest} ref={ref} />
        </StyledFieldSet>
      );

    case "password":
      return (
        <StyledFieldSet>
          <Label>
            {lowerCase === "co2e" ? (
              <Span disabled={props?.disabled}>
                Co<sub>2</sub>e {`${required ? "*" : ""}`}
              </Span>
            ) : (
              <Span disabled={props?.disabled}>{`${label} ${
                required ? "*" : ""
              }`}</Span>
            )}
          </Label>
          <InputPassword ref={ref} {...rest} />
        </StyledFieldSet>
      );

    case "textarea":
      return (
        <StyledFieldSet>
          {label ? (
            <Label>
              <Span disabled={props?.disabled}>{`${label} ${
                required ? "*" : ""
              }`}</Span>
            </Label>
          ) : null}
          <Textarea {...rest} ref={ref} />
        </StyledFieldSet>
      );

    case "datepicker":
      return (
        <StyledFieldSet>
          <Label>
            <Span className="z-[1]" disabled={props?.disabled}>{`${label} ${
              required ? "*" : ""
            }`}</Span>
          </Label>
          <DatePicker {...rest} />
        </StyledFieldSet>
      );

    case "file":
      return <Upload fullWidth={fullWidth} {...rest} ref={ref} />;

    case "autocomplete":
      return (
        <StyledFieldSet>
          <Label>
            <Span disabled={props?.disabled}>{`${label} ${
              required ? "*" : ""
            }`}</Span>
          </Label>
          <AutoComplete {...rest} />
        </StyledFieldSet>
      );

    case "checkbox":
      return <CheckBox ref={ref} label={label} required={required} {...rest} />;

    default:
      return (
        <StyledFieldSet>
          <Label>
            <Span disabled={props?.disabled}>{label}</Span>
          </Label>
          <Input {...rest} ref={ref} />
        </StyledFieldSet>
      );
  }
});

FieldSet.displayName = "FieldSet";

export default FieldSet;
